import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { principalRentOrOwn } = loanFormModel.formField;

class PrincipalOwns implements Rule {
  private principalId: any;

  public setPrincipalId(id: any) {
    this.principalId = id;
    return this;
  }

  private getPrincipal(data: Partial<ApplicationFormValues>) {
    return data.principals?.find(
      (principal) => principal.id === this.principalId
    );
  }

  public evaluate(application: Partial<ApplicationFormValues>): boolean {
    const principal = this.getPrincipal(application);

    const principalOwnsValue = principal?.[principalRentOrOwn.name] === 'Own';
    return principalOwnsValue ?? false;
  }
}

export default new PrincipalOwns();
